import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Box,
  Typography, Button, Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';
import {
  Close, ExpandMore, PunchClock, PointOfSale, ReceiptLong, Lock, Replay,
  PriceChange, Print,
} from '@mui/icons-material';

// Guía de uso en formato pregunta/respuesta (acordeón) — pensada para que
// un franquiciado o un empleado nuevo encuentre rápido la respuesta puntual
// que necesita, en vez de tener que leer un tutorial lineal de punta a
// punta. Vive en un componente propio (no adentro de Dashboard.jsx) porque
// es contenido, no lógica de pantalla.

const PREGUNTAS = [
  {
    icono: PunchClock,
    pregunta: '¿Cómo abro un turno?',
    respuesta: 'Antes de poder vender necesitás un turno de caja abierto en tu sucursal. Se abre desde "Turnos de caja".',
  },
  {
    icono: PointOfSale,
    pregunta: '¿Cómo registro una venta?',
    respuesta: 'Desde "Registrar": elegís los productos y confirmás. Hace falta tener un turno abierto (ver la pregunta anterior).',
  },
  {
    icono: ReceiptLong,
    pregunta: 'Me equivoqué en una venta, ¿la puedo corregir?',
    respuesta: 'Sí, podés modificarla o anularla desde "Registros de productos".',
  },
  {
    icono: Lock,
    pregunta: '¿Cómo cierro el turno?',
    respuesta: 'Desde "Turnos de caja", cerralo cuando termine el día (o ese turno) — se manda un resumen por mail a la sucursal.',
  },
  {
    icono: Replay,
    pregunta: 'Ya cerré el turno, ¿cómo registro otra venta?',
    respuesta: 'Tenés que abrir un turno nuevo — se vuelve a la primera pregunta.',
  },
  {
    icono: PriceChange,
    pregunta: '¿Cómo actualizo los precios cuando Grido manda la lista nueva?',
    respuesta: 'Subí el Excel que te manda Grido desde "Actualizar precios": el sistema cruza cada línea contra los productos ya '
      + 'mapeados y te muestra los cambios de precio antes de aplicar nada. Si alguna línea no se reconoce (o quedó mapeada a '
      + 'un producto que ya no existe), tocá "Ver mapeo de productos": ahí aparece tu Excel línea por línea, en verde lo que ya '
      + 'se pudo relacionar con un producto y en rojo lo que falta. En cada línea roja tocá "Elegir producto(s)" y buscá el '
      + 'producto (o productos, si esa línea agrupa varios sabores/tamaños) que corresponda en el catálogo; si todavía no '
      + 'existe en el sistema, desde ese mismo cartel hay un link para crearlo sin salir de la pantalla. Apenas la mapeás pasa '
      + 'a verde — se hace una sola vez por nombre, la próxima vez que subas un Excel esa línea ya se reconoce sola. Volvé a '
      + '"Actualizar precios" y confirmá para aplicar los cambios.',
  },
  {
    icono: Print,
    pregunta: '¿Cómo configuro la impresora de comandas en mi PC de caja?',
    respuesta: 'Instalá QZ Tray (gratis, desde qz.io) en esa PC. Pedile al administrador el archivo del certificado '
      + '(override.crt) — lo genera una sola vez desde Configuración y te lo puede mandar por mail o WhatsApp — y copialo '
      + 'en la carpeta C:\\Program Files\\QZ Tray\\ de esa PC (puede pedir permisos de administrador para guardarlo ahí). '
      + 'Reiniciá QZ Tray después de copiarlo (click derecho en su ícono de la bandeja → Exit, y volver a abrirlo). '
      + 'La primera vez que imprimís puede aparecer un cartel de QZ Tray pidiendo permiso — tocá "Allow".',
  },
];

function GuiaUso({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        Preguntas frecuentes
        <IconButton size="small" onClick={onClose}><Close fontSize="small" /></IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {PREGUNTAS.map(({ icono: Icono, pregunta, respuesta }, i) => (
          <Accordion key={i} defaultExpanded={i === 0} disableGutters elevation={0} square>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Icono color="primary" fontSize="small" />
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{pregunta}</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">{respuesta}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>Entendido</Button>
      </DialogActions>
    </Dialog>
  );
}

export default GuiaUso;
